import GroupAliases from './group-aliases';

export default function GroupAliasesPage() {
  return <GroupAliases />;
}
